import { render, staticRenderFns } from "./INDBOPROManagementBase.vue?vue&type=template&id=0ba8ac3c&"
import script from "./INDBOPROManagementBase.vue?vue&type=script&lang=js&"
export * from "./INDBOPROManagementBase.vue?vue&type=script&lang=js&"
import style0 from "./INDBOPROManagementBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VResponsive,VTab,VTabItem,VTabs,VTabsItems})
